export function getCustomStyles(autoHeight?: boolean, isHomepage?: boolean) {
    return {
        control: (provided: any, state: any) => ({
            ...provided,
            "background": "#ffffff",
            "border": state.isFocused && "unset",
            "borderColor": isHomepage ? (state.isDisabled ? "#C4C4C4" : "#000000") : "#CCCCCC",
            "fontWeight": 400,
            "fontSize": "1rem",
            "height": autoHeight ? "auto" : "44px",
            "borderRadius": "0.5rem",
            "marginRight": state.isFocused ? "1px" : 0,
            "&:hover": {
                borderColor: isHomepage ? "unset" : "hsl(0, 0%, 70%)",
                cursor: "pointer"
            }
        }),
        valueContainer: (provided: any) => ({
            ...provided,
            textOverflow: "ellipsis",
            maxWidth: "90%",
            whiteSpace: "nowrap",
            overflow: "hidden",
            flexWrap: autoHeight ? "wrap" : "nowrap",
            fontColor: "red"
        }),
        multiValue: (provided: any) => ({
            ...provided,
            width: "fit-content",
            backgroundColor: "#e8f5ff",
            paddingRight: "2px"
        }),
        menu: (provided: any) => ({
            ...provided,
            fontWeight: 400,
            zIndex: 1000,
            fontColor: "red"
        }),
        dropdownIndicator: (provided: any, state: any) => ({
            ...provided,
            "> svg": {
                fill: state.isDisabled ? "#C4C4C4" : "#000000",
                height: "0.875rem",
                width: "0.875rem"
            }
        }),
        option: (prodived: any, { isDisabled }: { isDisabled: boolean }) => {
            return {
                ...prodived,
                border: isDisabled ? "none" : "blue"
            };
        }
    };
}
